/**
 * Online video downloader - download video
 *
 * Its single web-accessible-resource entry lists `*` (every bundled file) matched to
 * every http(s) origin, with no `use_dynamic_url` — so the whole package, icons and
 * scripts alike, is fetchable from any page at a fixed URL. The 128px icon is the
 * cleanest signal (an image, so it loads with no CORS grant), and the extension's own
 * `rules.json` and `popup.html` corroborate.
 *
 * Manifest verified against version 1.4.4.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'ledkggjjapdgojgihnaploncccgiadhg';

export const onlineVideoDownloader: ExtensionDefinition = {
  id: ID,
  name: 'Online video downloader - download video',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  notes:
    'Exposes every bundled file (resources: ["*"]) to every http(s) origin with no ' +
    'dynamic URL. The icon loads without a CORS grant; detection is conclusive.',
  signals: [
    {
      id: 'war-icon-128',
      kind: 'web-accessible-resource',
      description:
        'Load icons/icon128.png via <img> — exposed to every origin and readable without ' +
        'a CORS grant, so it works even under a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'icons/icon128.png'),
    },
    {
      id: 'war-rules-json',
      kind: 'web-accessible-resource',
      description:
        'Fetch rules.json — the declarativeNetRequest ruleset, a stable non-icon path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'rules.json'),
    },
    {
      id: 'war-popup-html',
      kind: 'web-accessible-resource',
      description: 'Fetch popup.html — the action popup document, a third path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'popup.html'),
    },
  ],
};
